// src/hooks/internal/useOutletRenderer.ts
import { useMemo, useRef } from "react";
import { useOutlets } from "../../context/NovuUIContext.js";
import { useIsomorphicLayoutEffect } from "./useIsomorphicLayoutEffect.js";
function useOutletRenderer(renderProp) {
  const outlets = useOutlets();
  const latest = useRef(renderProp);
  latest.current = renderProp;
  const hasRenderer = !!renderProp;
  useIsomorphicLayoutEffect(() => {
    if (hasRenderer) {
      outlets.invalidate();
    }
  }, [outlets, hasRenderer, renderProp]);
  return useMemo(() => {
    if (!hasRenderer) {
      return void 0;
    }
    return (el, ...args) => outlets.mount(el, (...renderArgs) => latest.current?.(...renderArgs), args);
  }, [outlets, hasRenderer]);
}
export {
  useOutletRenderer
};
//# sourceMappingURL=useOutletRenderer.js.map